module.exports = __webpack_public_path__ + "img/logo.56b6a5b7.png";